import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App.tsx";
import "overlayscrollbars/overlayscrollbars.css";
import "./index.css";
import "survey-core/defaultV2.min.css";

// import i18n (needs to be bundled ;))
import "./i18n";

ReactDOM.createRoot(document.getElementById("root") as HTMLElement).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
